import React, { useState } from 'react';
import { Sparkle20Filled } from '@fluentui/react-icons';

/**
 * Imagen del agente de IA. Se resuelve con `require` como el resto de las
 * imágenes del proyecto: webpack la emite en `static/media` con hash de
 * contenido, así que reemplazarla no queda tapado por la caché del navegador.
 */
export const IA_AGENT_IMAGE_URL: string = require('../../../assets/img/alphi_sticker.webp');

interface IProps {
    /** Lado del cuadrado, en px. */
    size?: number;
    className?: string;
    /**
     * Texto alternativo. Vacío por defecto: al lado de un rótulo que ya dice
     * "análisis", la imagen es decorativa y anunciarla sólo duplica la lectura.
     */
    alt?: string;
}

export const IAAgentAvatar = ({ size = 20, className, alt = '' }: IProps) => {
    const [failed, setFailed] = useState<boolean>(false);

    // El archivo existe en el build, pero el servidor puede rechazarlo igual:
    // IIS devuelve 404 para las extensiones que no tiene declaradas en su mapa
    // MIME, y .webp es una de ellas. Ahí el ícono ocupa su lugar en vez de
    // dejar el hueco roto del navegador.
    if (failed) {
        return <Sparkle20Filled className={className} style={{ fontSize: size }} />;
    }

    return (
        <img
            src={IA_AGENT_IMAGE_URL}
            width={size}
            height={size}
            alt={alt}
            aria-hidden={alt ? undefined : true}
            className={className}
            onError={() => setFailed(true)}
            style={{ display: 'block', borderRadius: '50%', flexShrink: 0 }}
        />
    );
};

export default IAAgentAvatar;
